import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  getChildren(urlSearchParams) {
    return http.get(endpoints.get('filterChildren', { filter: 'filter-assigned' }), {
      params: urlSearchParams,
      withCredentials: true
    })
  },
  filterChildren(payload) {
    return http.post(endpoints.get('filterChildren', { filter: 'filter' }), payload)
  },
  getCoordinatorsChildren(urlSearchParams) {
    return http.get(endpoints.get('filterChildren', { filter: 'coordinator-list' }), {
      params: urlSearchParams,
      withCredentials: true
    })
  }
}
